var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"allNr"},[_c('page-back',{attrs:{"title":"第三方SDK清单","showHome":false,"customFn":_vm.customFn}}),_c('div',[_vm._v("表格较宽，左右滑动查看全部内容")]),_c('vtable',{attrs:{"data":_vm.data,"header":_vm.header,"height":150}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }